<template>
  <span class="order-status">
    <!-- <bx-tag v-if="status==0" :color="dark ? 'outline' : 'outline-dark'">{{$t('lang.box_status.status_0')}}</bx-tag> -->
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <!-- <bx-tag v-if="status==0" :color="dark ? 'outline' : 'outline-dark'">{{$t('lang.order_status.status_0')}}</bx-tag> -->
        <div v-bind="attrs" v-on="on">
          <bx-tag v-if="status == 3" color="yellow">{{
            $t("lang.box_status.status_3")
          }}</bx-tag>
          <bx-tag v-if="status == 1"
            ><img src="@/assets/i/triangle-outline.svg"
          /></bx-tag>
          <bx-tag v-if="status == 2"
            ><i class="fa fa-check green-icon"></i
          ></bx-tag>
          <bx-tag v-if="status == 4"
            ><v-icon>mdi-cancel</v-icon>
          </bx-tag>
        </div>
      </template>
      <span>{{ statusTooltip }}</span>
    </v-tooltip>
  </span>
</template>
<script>
export default {
  name: "bx-box-status",
  props: {
    status: {
      type: [Number, String],
      default: 0
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusTooltip: {
      get() {
        let text;
        if (this.status === 0) {
          text = this.$t("lang.box_status.status_0");
        } else if (this.status === 1) {
          text = this.$t("lang.box_status.status_1");
        } else if (this.status === 2) {
          text = this.$t("lang.box_status.status_2");
        } else if (this.status === 3) {
          text = this.$t("lang.box_status.status_3");
        } else if (this.status === 4) {
          text = this.$t("lang.box_status.status_4");
        }
        return text;
      }
    }
  }
};
</script>
